const Spanish = {
  "email":  "Correo",
  "enter your email address": "Introduce tu dirección de correo electrónico",
  "enter your phone number": "Ingrese su número telefónico",
  "login": "Ingresar",
  "login with a link": "Inicia sesión con un enlace",
  "phone number": "Celular",
  "phone number and email do not match": "El número de teléfono y el correo electrónico no coinciden",
  "next": "Siguiente",
  "ready": "Listo",
  "send": "Enviar",
  "send me a login link": "Envíame un enlace de inicio de sesión",
  "scan qrcode to login": "Escanee el código QR para iniciar sesión",
  "start": "Empezar",
  "that email address is not recognized": "Esa correo electrónico no es reconocida.",
  "that phone number is not recognized": "Ese numero de telefono no es reconocido",
  "unique code": "Codigo Unico",
  "we sent you a code": "Te enviamos un codigo",
  "your email": "Tu correo electrónico",

  // Chat Widget
  "chat.greeting.default": "¡Hola! 👋 Estoy aquí para ayudarte a pedir. ¿Qué te gustaría pedir hoy?",
  "chat.greeting.welcome_back": "¡Bienvenido de nuevo, {NAME}! 👋\n\nVeo que has pedido aquí antes. ¿Te gustaría:\n• Pedir algo que hayas probado antes\n• Probar algo nuevo\n• Ver lo que es popular",
  "chat.suggestions.show_menu": "Muéstrame el menú",
  "chat.suggestions.recommend": "¿Qué me recomiendas?",
  "chat.suggestions.cheap": "Quiero algo barato",
  "chat.suggestions.order_again": "Pedir {NAME} otra vez",
  "chat.error.init_failed": "Tuve problemas para iniciar. Por favor intenta de nuevo.",
  "chat.error.message_failed": "Algo salió mal. Por favor intenta de nuevo.",

  // Chat Header
  "chat.header.title": "Asistente de Pedidos",
  "chat.header.close": "Cerrar chat",

  // Chat Input
  "chat.input.placeholder": "Escribe tu mensaje...",
  "chat.input.voice": "Entrada de voz",
  "chat.input.send": "Enviar mensaje",
  "chat.input.voice_not_supported": "La entrada de voz no es compatible con tu navegador.",

  // Chat Bubble
  "chat.bubble.open": "Abrir chat",

  // Language Switcher
  "chat.language.switch": "Cambiar a inglés",
  "chat.language.switch_to_english": "Cambiar a español"
}

export default Spanish;
